export var EAdditionalCostField;
(function (EAdditionalCostField) {
    EAdditionalCostField["Description"] = "description";
    EAdditionalCostField["StartPrice"] = "startPrice";
    EAdditionalCostField["CurrentPrice"] = "currentPrice";
    EAdditionalCostField["PriceVat"] = "priceVat";
    EAdditionalCostField["PriceNoVatType"] = "priceNoVatType";
    EAdditionalCostField["PriceType"] = "priceType";
    EAdditionalCostField["IsIndexable"] = "isIndexable";
    EAdditionalCostField["AddedAt"] = "addedAt";
    EAdditionalCostField["LastIndexedAt"] = "lastIndexedAt";
    EAdditionalCostField["StartIndexMonth"] = "startIndexMonth";
    EAdditionalCostField["StartIndexYear"] = "startIndexYear";
})(EAdditionalCostField || (EAdditionalCostField = {}));
